<template>
  <single-panel-page>
    <h5>Change password</h5>

    <div
      v-show="!passwordChanged"
      class="form"
      :class="{ 'loader-cover': inProgress }"
    >
      <input
        v-model="password"
        class="form-control current-password"
        type="password"
        placeholder="Current password"
        autofocus
        @keyup.enter="submit()"
      />
      <router-link
        class="text-muted text-xs forgot-password"
        :to="{ name: 'forgotPasswordPage' }"
      >
        I don't remember my current password
      </router-link>
      <p
        class="text-sm text-red-600 mb-4"
        v-for="err in errors.password"
        :key="err"
      >
        {{ err }}
      </p>

      <input
        v-model="newPassword"
        class="form-control"
        type="password"
        placeholder="New password"
        @keyup.enter="submit()"
      />

      <p
        class="text-sm text-red-600 mb-4"
        v-for="err in errors.new_password"
        :key="err"
      >
        {{ err }}
      </p>
      <password class="mb-6" :value="newPassword" />

      <input
        v-model="confirmNewPassword"
        class="form-control"
        type="password"
        placeholder="Confirm new password"
        @keyup.enter="submit()"
      />

      <p
        class="text-sm text-red-600 mb-4"
        v-for="err in errors.confirm_new_password"
        :key="err"
      >
        {{ err }}
      </p>
    </div>
    <div v-show="passwordChanged" class="row animated fadeIn">
      <div class="col-sm-12">
        <p class="text-success">Your password has been updated</p>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 text-right">
        <button
          v-show="!passwordChanged"
          class="btn btn-block btn-primary text-uppercase"
          :disabled="inProgress"
          @click="submit()"
        >
          <span>Submit</span>
        </button>
      </div>
    </div>

    <div slot="bottom">
      <span class="splash-box-footer">
        <router-link class="text-yellow" :to="dashboardRoute"
          >Back to app</router-link
        >
      </span>
    </div>
  </single-panel-page>
</template>

<script>
import Auth from 'services/Auth'
import { mapGetters } from 'vuex'

const getInitialErrors = () => ({ password: [], newPassword: [] })
export default {
  data: function () {
    return {
      password: '',
      newPassword: '',
      confirmNewPassword: '',
      inProgress: false,
      errors: getInitialErrors(),
      passwordChanged: false,
    }
  },
  mounted() {
    this.clearErrors()
  },
  computed: {
    hasErrors: function () {
      return this.errors.newPassword.length || this.errors.password.length
    },
    ...mapGetters({
      dashboardRoute: 'user/dashboardRoute',
    }),
  },
  methods: {
    async submit() {
      this.inProgress = true
      const password = this.password
      const newPassword = this.newPassword
      const confirmNewPassword = this.confirmNewPassword
      const request = Auth.changePassword({
        password,
        newPassword,
        confirmNewPassword,
      })
      try {
        const response = await request
        this.passwordChanged = true
        this.clearErrors()
      } catch (error) {
        if (error.response) {
          this.errors = error.response.data
        } else {
          throw error
        }
      } finally {
        this.inProgress = false
      }
    },
    clearErrors() {
      this.errors = getInitialErrors()
    },
  },
}
</script>

<style lang="scss" scoped>
.splash-box {
  .current-password {
    margin-bottom: 0px;
  }
  .forgot-password {
    margin-top: 0px;
    margin-bottom: 10px;
  }
}
</style>
